import { waitFor } from "./async";
import { KryptonConstants } from "./krypton_constants";

export class AnimationHelper {
    private slideInClass: any
    private slideOutClass: any
    private slideBackInClass: any
    private slideBackOutClass: any
    private animationTime: number = KryptonConstants.scrollBufferTime;
    private intermediateAnimationTime: number = KryptonConstants.showHideIntermediateAnimationTime;
    static ANIMATE_VERTICAL = new AnimationHelper("vertical");
    static ANIMATE_HORIZONTAL = new AnimationHelper("horizontal");
    direction: string
    static getAnimationHelper(direction: string) {
        return direction === "vertical" ? AnimationHelper.ANIMATE_VERTICAL : AnimationHelper.ANIMATE_HORIZONTAL;
    }
    static isAnimated(page: any): boolean {
        return page?.animated;
    }
    private constructor(direction: string) {
        this.direction = direction;
        if (direction === "horizontal") {
            this.animationTime = KryptonConstants.horizontalSlideAnimationTime;
            this.intermediateAnimationTime = KryptonConstants.revealAnimationTime;
        }
        this.slideInClass = this.getAnimationClass("in");
        this.slideOutClass = this.getAnimationClass("out");
        this.slideBackInClass = this.getAnimationClass("in", true);
        this.slideBackOutClass = this.getAnimationClass("out", true);
    }
    getSlideIn(back: boolean = false) {
        return back ? this.slideBackInClass : this.slideInClass
    }
    getSlideOut(back: boolean = false) {
        return back ? this.slideBackOutClass : this.slideOutClass
    }
    getAnimationClass(inOrOut: string, isSlidingBack: boolean = false) {
        if (isSlidingBack) {
            if (inOrOut === "in") {
                if (this.direction === "horizontal") {
                    return "slideInFromLeft"
                } else {
                    return "slideInFromTop"
                }
            } else {
                if (this.direction === "horizontal") {
                    return "slideOutToRight"
                } else {
                    return "slideOutToBottom"
                }
            }
        } else {
            if (inOrOut === "in") {
                if (this.direction === "horizontal") {
                    return "slideInFromRight"
                } else {
                    return "slideInFromBottom"
                }
            } else {
                if (this.direction === "horizontal") {
                    return "slideOutToLeft"
                } else {
                    return "slideOutToTop"
                }
            }
        }
    }

    lock(donotCloseLoadingCurtain: boolean = false) {
        if (!donotCloseLoadingCurtain) {
            window["kryptonApp"]().loadingCurtain.open = false;
        }
        if (this.direction === "vertical") {
            window["kryptonApp"]()?.showOrHideFooter(false);
        }
    }

    unLock(donotCloseLoadingCurtain: boolean = false) {
        if (!donotCloseLoadingCurtain) {
            window["kryptonApp"]().loadingCurtain.open = false;
        }
        if (this.direction === "vertical") {
            window["kryptonApp"]()?.showOrHideFooter(true);
        }
    }

    async begin(inSlide: any, outSlide: any, back: boolean = false) {
        // Animate out the current slide
        if (inSlide != outSlide) outSlide.classList.add(this.getSlideOut(back));
        //if (this.direction === "vertical") {
        // If vertical, main slide has to go up completely before we open the new slide, so let's wait
        await waitFor(this.intermediateAnimationTime);
        //}
        if (!back && inSlide != outSlide) {
            outSlide.open = false;  // If not sliding back, hide the out-slide before showing the in-slide
        }
        inSlide.open = true;
        // Out slide is off (animation amy still remain), now animate in new slide
        inSlide.classList.add(this.getSlideIn(back));
    }
    async release(inSlide: any, outSlide: any, back: boolean = false) {
        if (inSlide != outSlide) outSlide.open = false;
        if (inSlide != outSlide) outSlide.classList.remove(this.getSlideOut(back));
        inSlide.classList.remove(this.getSlideIn(back));
        this.unLock();
    }
    async animateNavigateToSlide(inSlide: any, outSlide: any) {
        this.lock();
        await this.begin(inSlide, outSlide);
        await waitFor(this.animationTime);// Wait for the animation to complete
        await this.release(inSlide, outSlide)
    }

    async animateNavigateBackToSlide(inSlide: any, outSlide: any) {
        this.lock();
        await this.begin(inSlide, outSlide, true);
        await waitFor(this.animationTime);// Wait for the animation to complete
        await this.release(inSlide, outSlide, true)
    }

    async animateSlideOut(slide: any, back: boolean = false, animateOnlyIfAnimatedBefore: boolean = false, donotCloseLoadingCurtain: boolean = false) {
        this.lock(donotCloseLoadingCurtain);
        if (slide?.animated) {
            slide?.classList?.remove(slide?.animated);
        }
        if (!animateOnlyIfAnimatedBefore || (AnimationHelper.isAnimated(slide) && AnimationHelper.isAnimated(slide?.opener))) {
            // openSlider may have called for filter (My Contract Rights for example).  Animation required only for subsequent navigations like 
            // select company name. Ledger to filter and back from filter to ledger is not animated.
            slide.animated = this.getSlideOut(back);
            slide?.classList?.add(slide.animated);
            await waitFor(this.intermediateAnimationTime + 100);
        }
    }

    async animateSlideIn(slide: any, back: boolean = false, animateOnlyIfAnimatedBefore: boolean = false, donotCloseLoadingCurtain: boolean = false) {
        if (!donotCloseLoadingCurtain) {
            window["kryptonApp"]().loadingCurtain.open = false;
        }
        if (slide?.animated) {
            slide?.classList?.remove(slide?.animated);
        }
        if (!animateOnlyIfAnimatedBefore || (AnimationHelper.isAnimated(slide) && AnimationHelper.isAnimated(slide?.opener))) {
            // openSlider may have called for filter (My Contract Rights for example).  Animation required only for subsequent navigations like 
            // select company name. Ledger to filter and back from filter to ledger is not animated.
            slide.animated = this.getSlideIn(back);
            slide?.classList?.add(slide.animated);
            await waitFor(this.animationTime); // Wait for animation to complete
            slide?.classList?.remove(slide.animated);
        }
        this.unLock(donotCloseLoadingCurtain);
    }
}

